import { connect } from 'react-redux'
import pluralize from 'pluralize'
import { LinkRegistyIcon } from 'components/icons'
import SetupGoal from './setup-goal'
import { getExternalRegistriesCount } from 'registry/reducers'

function getText(state) {
  const count = getExternalRegistriesCount(state)
  return count > 0
    ? `You've added ${count} other ${pluralize('registry', count)}.`
    : 'Add a registry from another site.'
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <LinkRegistyIcon alternate={ownProps.alternateIcon} />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
